<template>
  <div class="w-full pt-6 flex">
    <div class="w-11/12 mx-auto flex flex-wrap py-4">
      <div class="w-full flex justify-center mt-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="174"
          height="199"
          fill="none"
          viewBox="0 0 174 199"
        >
          <circle cx="86.512" cy="99.488" r="86.512" fill="#E0E0E0" />
          <g clip-path="url(#clip0)">
            <path
              fill="#FF5252"
              d="M132.999 30.018c-.856-.248-1.347-1.142-1.099-1.997l1.554-5.36c1.476-5.087-1.463-10.426-6.549-11.901-5.087-1.475-10.426 1.463-11.901 6.55-.248.855-1.142 1.347-1.997 1.099-.856-.248-1.348-1.142-1.099-1.998 1.97-6.794 9.1-10.718 15.895-8.748 6.794 1.971 10.718 9.102 8.747 15.896l-1.554 5.36c-.248.855-1.142 1.347-1.997 1.1z"
            />
            <g filter="url(#filter0_ddd)">
              <path
                fill="#fff"
                d="M36.381 162.643h100.263c3.628 0 6.569-2.941 6.569-6.569V32.026c0-3.628-2.941-6.569-6.569-6.569H36.381c-3.628 0-6.569 2.94-6.569 6.569v124.048c0 3.628 2.942 6.569 6.57 6.569z"
              />
            </g>
            <path
              fill="#FF5252"
              d="M112.042 53.166c-5.491-1.593-8.662-7.355-7.07-12.845l6.936-23.912c.248-.855 1.142-1.347 1.997-1.1.855.249 1.347 1.143 1.099 1.998l-6.935 23.912c-1.097 3.782 1.088 7.753 4.871 8.85 3.782 1.097 7.753-1.088 8.85-4.87l6.935-23.912c.719-2.48-.713-5.081-3.192-5.8-2.479-.72-5.081.713-5.8 3.192l-4.282 14.762c-.248.855-1.142 1.347-1.997 1.1-.855-.249-1.347-1.143-1.099-1.998l4.282-14.762c1.214-4.187 5.608-6.605 9.794-5.39 4.187 1.213 6.605 5.607 5.391 9.794l-6.936 23.911c-1.592 5.49-7.354 8.662-12.844 7.07zM120.167 105.656H52.382c-1.316 0-2.382-1.067-2.382-2.383s1.066-2.382 2.382-2.382h67.785c1.316 0 2.382 1.066 2.382 2.382s-1.066 2.383-2.382 2.383z"
            />
            <path
              fill="#404B58"
              d="M96.315 121.3H52.56c-1.316 0-2.383-1.067-2.383-2.382 0-1.316 1.067-2.383 2.383-2.383h43.755c1.316 0 2.383 1.067 2.383 2.383 0 1.315-1.067 2.382-2.383 2.382zM106.639 136.949h-54.08c-1.315 0-2.381-1.067-2.381-2.383s1.066-2.382 2.382-2.382h54.079c1.316 0 2.382 1.066 2.382 2.382s-1.066 2.383-2.382 2.383zM58.382 82.996c-1.316 0-2.382-1.066-2.382-2.382v-4.677c0-1.316 1.066-2.382 2.382-2.382s2.383 1.066 2.383 2.382v4.677c0 1.316-1.066 2.382-2.383 2.382zM114.199 82.996c-1.316 0-2.383-1.066-2.383-2.382v-4.677c0-1.316 1.067-2.382 2.383-2.382s2.382 1.066 2.382 2.382v4.677c0 1.316-1.067 2.382-2.382 2.382zM86.434 78.437c3.535 0 6.897 1.532 9.224 4.201.864.992.76 2.497-.231 3.362-.993.864-2.497.76-3.362-.231-1.421-1.632-3.474-2.567-5.631-2.567-2.158 0-4.21.936-5.631 2.567-.864.991-2.37 1.095-3.362.23-.992-.864-1.095-2.369-.23-3.36 2.326-2.67 5.688-4.202 9.223-4.202z"
            />
          </g>
          <circle cx="144" cy="171" r="28" fill="#FF5252" />
          <path
            stroke="#fff"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="4"
            d="M135 180l17.045-18M134.523 162.477l18 17.045"
          />
          <defs>
            <clipPath id="clip0">
              <path
                fill="#fff"
                d="M0 0H162.642V191H0z"
                transform="translate(5.191)"
              />
            </clipPath>
            <filter
              id="filter0_ddd"
              width="157.4"
              height="183.186"
              x="7.812"
              y="8.457"
              color-interpolation-filters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              />
              <feOffset dy="7" />
              <feGaussianBlur stdDeviation="4" />
              <feColorMatrix
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
              />
              <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
              <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              />
              <feOffset dy="5" />
              <feGaussianBlur stdDeviation="11" />
              <feColorMatrix
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
              />
              <feBlend in2="effect1_dropShadow" result="effect2_dropShadow" />
              <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              />
              <feOffset dy="12" />
              <feGaussianBlur stdDeviation="8.5" />
              <feColorMatrix
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
              />
              <feBlend in2="effect2_dropShadow" result="effect3_dropShadow" />
              <feBlend
                in="SourceGraphic"
                in2="effect3_dropShadow"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      </div>
      <div class="w-full pt-10 pb-4 flex flex-wrap px-10 text-center">
        <span
          class="w-full text-zt-xl text-black font-normal"
          v-html="$sanitize(errorMsg)"
        >
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    errorMsg: {
      type: String,
      default: "",
    },
  },
};
</script>

<style></style>
